import { FormControl } from '@angular/forms';
export enum TfaResetControlName {
  ResetToken = 'resetToken',
}

export interface TfaResetFormGroup {
  [TfaResetControlName.ResetToken]: FormControl<string>;
}
